// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings[data-v-0568bbfe]{min-height:348px}@media(max-width:767px){.settings[data-v-0568bbfe]{padding-bottom:30px!important}}.settings__content[data-v-0568bbfe]{position:relative}@media(max-width:1279px){.settings__content[data-v-0568bbfe] .changes-saved:not(:nth-child(2)){position:absolute;top:-80px;right:0}}@media(max-width:767px){.settings__content[data-v-0568bbfe] .changes-saved:not(:nth-child(2)){top:-30px}}", ""]);
// Exports
module.exports = exports;
